import React, { useEffect, useState } from "react";
import Templates from "../signTemplates/Templates";

import { Col, Container, Offcanvas, Row } from "react-bootstrap";

import image from "../../../assets/lang/icons.json";
import { currentFeature } from "../../../slice/features";
import { useDispatch, useSelector } from "react-redux";
import style from "./FeatureModule.module.css";
import SelectFeature from "./selectFeature/selectFeature";
import { useRef } from "react";

const FeatureModule = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const userFeature = useSelector((state) => state.userFeatures);
  const userTemplate = useSelector((state) => state.userTemplate);

  const [tempName, setTempName] = useState("temp1");
  const [FeaturesTemp, setFeaturesTemp] = useState("");
  const TempsRef = useRef();

  useEffect(() => {
    // dispatch(currentFeature(FeaturesTemp));
    setFeaturesTemp(userFeature.currentFeature[0].currentFeature);
    setTempName(userTemplate.template[0].templateName);
  }, [dispatch, FeaturesTemp, userFeature]);

  return (
    <Offcanvas
      placement="end"
      show={open === true && FeaturesTemp !== "" ? true : false}
      onHide={handleClose}
      className={`${style.Offcanvas}`}
      // backdrop="static"
    >
      <Offcanvas.Body>
        <Container className="my-3">
          <Row>
            <Col lg={6}>
              <SelectFeature TemplateType={FeaturesTemp} key={FeaturesTemp} />
            </Col>
            <Col lg={6}>
              <div className="card border-0 shadow text-start d-flex justify-content-center">
                <div className="card-header p-0 text-white">
                  <div className="bg-blue p-0">
                    <p className="ms-2">Preview</p>
                  </div>

                  <div className="w-100 bg-white text-start  m-auto">
                    <div className="card border-0 ">
                      <div className="card-body ">
                        <div
                          className="wrapper d-flex justify-content-center align-items-center "
                          style={{ minHeight: "300px" }}
                          ref={TempsRef}
                        >
                          <div className="">
                            <Templates TemplateType={tempName} key={tempName} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default FeatureModule;
